import { z } from 'zod'

/**
 * 將 Enum 轉為 zod 空字串 ｜ Enum Schema
 */
export const enumWithEmpty = <T extends z.EnumLike>(value: T) =>
  z.union([z.literal(''), z.nativeEnum(value)])
